import { useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import Swal from "sweetalert2";
import { FaPaperPlane } from "react-icons/fa";
import { userServices } from "../../APIServices/UserData/userServices";

const ChangeEmail = ({
  Show,
  Hide,
  Title,
  isDark,
  currentEmail,
  getCurrectLoginUser,
}) => {
  const [email, setEmail] = useState("");
  const [otpStatus, setOTPStatus] = useState("");
  const [otp, setOTP] = useState("");
  const [loader, setLoader] = useState("");

  const sendEmailOTP = async () => {
    setLoader(true);
    let userData = {};
    userData.email = email;
    let data = await userServices.sendEmailOTP(userData);
    if (data?.status === "otpVerification") {
      setOTPStatus(data?.status || "");
      setEmail(data?.email || email);
    }
    setLoader(false);
  };

  const updateNewEmail = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Verify and Update Email?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Verify and Update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let userData = {};
        userData.email = email;
        userData.otp = otp;
        let data = await userServices.updateNewEmail(userData);
        if (data?.statusCode === 200) {
          getCurrectLoginUser()
          const existingList =
            JSON.parse(localStorage.getItem("accountList")) || [];
          let fianlList = existingList.map(user =>
            user.email === currentEmail
              ? { ...user, email: email }
              : user
          );
          localStorage.setItem("accountList", JSON.stringify(fianlList));
          setEmail("");
          setOTPStatus("");
          setOTP("");
          Hide()
        }
        setLoader(false);
      }
    });
  };
  return (
    <Modal show={Show} onHide={Hide} size="md">
      <Modal.Header
        closeButton
        className={`${isDark ? "bg-dark text-light" : "bg-light"} p-3 border-bottom`}
      >
        <Modal.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`rounded-bottom ${isDark ? "bg-dark" : "bg-white"}`}>
        <Form.Group className="mb-2">
          <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
            New Email Address
          </Form.Label>
          <Form.Control
            type="email"
            value={email}
            disabled={otpStatus === "otpVerification"}
            onChange={(e) => setEmail(e.target.value)}
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Email Address"
          />
        </Form.Group>
        {otpStatus === "otpVerification" && (
          <Form.Group className="mb-2">
            <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
              OTP
            </Form.Label>
            <Form.Control
              type="number"
              value={otp}
              onChange={(e) => setOTP(e.target.value)}
              className="interactive-input rounded-1"
              style={{ fontSize: 12, padding: "6px 15px" }}
              placeholder="Enter OTP"
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="hstack justify-content-end">
          {otpStatus === "otpVerification" ?
            <Button
              disabled={loader || !email || !otp}
              variant="outline-primary"
              style={{ fontSize: 13 }}
              onClick={updateNewEmail}
              title="Verify and Uppdate"
              className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
            >
              <MdOutlineMarkEmailRead /> Verify and Update
            </Button>
            :
            <Button
              disabled={loader || !email}
              variant="outline-primary"
              style={{ fontSize: 13 }}
              onClick={sendEmailOTP}
              title="Send Confirmation"
              className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
            >
              <FaPaperPlane /> Send Confirmation
            </Button>
          }
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangeEmail;
